import { render, staticRenderFns } from "./AddSettlementCommentModal.vue?vue&type=template&id=401e361b&"
import script from "./AddSettlementCommentModal.vue?vue&type=script&lang=js&"
export * from "./AddSettlementCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports